export default __webpack_public_path__ + "static/media/telegram.cc98ba75.svg";